import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import SourceTypeCard from "./SourceTypeCard";
import LanguageIcon from "@material-ui/icons/Language";
import FolderSharedIcon from "@material-ui/icons/FolderShared";
import { useTranslation } from "react-i18next";
import { getClientId } from "../../../utils/OAuthClientData";
const DriveIcon = () => (
  <div style={{ textAlign: "center", paddingTop: 20, marginBottom: -20 }}>
    <span style={{ fontSize: 80 }} class="mdi mdi-google-drive" />
  </div>
);
const DropboxIcon = () => (
  <div style={{ textAlign: "center", paddingTop: 20, marginBottom: -20 }}>
    <span style={{ fontSize: 80 }} class="mdi mdi-dropbox" />
  </div>
);
const OfficeIcon = () => (
  <div style={{ textAlign: "center", paddingTop: 20, marginBottom: -20 }}>
    <span style={{ fontSize: 80 }} class="mdi mdi-office" />
  </div>
);
const SalesforceIcon = () => (
  <div style={{ textAlign: "center", paddingTop: 20, marginBottom: -20 }}>
    <span style={{ fontSize: 80 }} class="mdi mdi-salesforce" />
  </div>
);
const OneDriveIcon = () => (
  <div style={{ textAlign: "center", paddingTop: 20, marginBottom: -20 }}>
    <span style={{ fontSize: 80 }} class="mdi mdi-onedrive" />
  </div>
);

function SourceTypeSelector(props) {
  const { t } = useTranslation();
  const sourceTypes = [
    {
      title: "SharePoint",
      type: "SHAREPOINT",
      id: "sharepoint-card",
      titleTranslated: t("sharepoint_365_title"),
      description: t("sharepoint_365_description"),
      icon: OfficeIcon,
    },
    {
      title: "OneDrive",
      type: "ONEDRIVE",
      id: "onedrive-card",
      titleTranslated: t("onedrive_title"),
      description: t("onedrive_description"),
      icon: OneDriveIcon,
    },
    {
      title: "Google Drive",
      type: "GOOGLE_DRIVE",
      id: "google-drive-card",
      titleTranslated: t("google_drive_title"),
      description: t("google_drive_description"),
      icon: DriveIcon,
    },
    {
      title: "Dropbox",
      type: "DROPBOX",
      id: "dropbox-card",
      titleTranslated: t("dropbox_title"),
      description: t("dropbox_description"),
      icon: DropboxIcon,
    },
    {
      title: "Salesforce",
      type: "SALESFORCE",
      id: "salesforce-card",
      titleTranslated: t("salesforce_title"),
      description: t("salesforce_description"),
      icon: SalesforceIcon,
    },
    {
      title: "File Share",
      type: "FILE_SHARE",
      id: "file-share-card",
      titleTranslated: t("file_share_title"),
      description: t("file_share_description"),
      icon: FolderSharedIcon,
    },
    {
      title: "Website",
      type: "WEBSITE",
      id: "website-card",
      titleTranslated: t("website_title"),
      description: t("website_description"),
      icon: LanguageIcon,
    },
  ];
  const getClientIdComp = (type) => {
    getClientId(type, (response) => {
      props.setClientId(response.res.data);
    });
    props.onSelectSource(type);
    // props.setClientId(response.res.data);
    // props.onSelectSource(response.type);
    // let requestType = "";
    // if (type === "GOOGLE_DRIVE") {
    //   requestType = "GOOGLE_CLIENT_ID";
    // } else if (type === "SHAREPOINT") {
    //   requestType = "MICROSOFT_CLIENT_ID";
    // } else if (type === "SALESFORCE") {
    //   requestType = "SALESFORCE_CLIENT_ID";
    // } else if (type === "DROPBOX") {
    //   requestType = "DROPBOX_BUSINESS_CLIENT_ID";
    // } else if (type === "DROPBOX") {
    //   requestType = "DROPBOX_USER_CLIENT_ID";
    // } else {
    //   props.onSelectSource(type);
    // }
    // axios.get(`/oauthdetails/${requestType}/`, {}).then((res) => {
    //   props.setClientId(res.data);
    //   props.onSelectSource(type);
    // });
  };
  return (
    <>
      {props.show ? (
        <Grid container spacing={2}>
          {sourceTypes.map((type, idx) => {
            return (
              <Grid item xs={12} sm={6} md={4} xl={3} key={idx}>
                <SourceTypeCard
                  title={type.title}
                  description={type.description}
                  icon={type.icon}
                  id={type.id}
                  titleTranslated={type.titleTranslated}
                  onSelect={() => getClientIdComp(type.type)}
                />
              </Grid>
            );
          })}
        </Grid>
      ) : null}
    </>
  );
}

export default SourceTypeSelector;
